<app-card [classes]="classes"
          [paddingClasses]="paddingClasses"
          [showTopImage]="showTopImage"
          [showBorder]="showBorder"
          [limitDescription]="limitDescription"
          [imageUrl]="imageUrl"
          [mediaItems]="mediaItems"
          [mobileMode]="mobileMode"
          [topImageLink]="topImageLink"
          [topImageLinkText]="topImageLinkText"
          [topLeft]="topLeft"
          [topLeftLink]="topLeftLink"
          [topLeftClasses]="topLeftClasses"
          [topLeftTextClasses]="topLeftTextClasses"
          [topRight]="topRight"
          [topRightClasses]="topRightClasses"
          [topRightTextClasses]="topRightTextClasses"
          [title]="title"
          [titleClasses]="titleClasses"
          [subTitle]="subTitle"
          [subtitleClasses]="subtitleClasses"
          [description]="description"
          [descriptionClasses]="descriptionClasses"
          [bottomLeft]="bottomLeft"
          [bottomLeftClasses]="bottomLeftClasses"
          [buttonClasses]="buttonClasses"
          [buttonRoute]="buttonRoute"
          [buttonText]="!!buttonRoute ? 'Tickets' : ''"
          [linkText]="(!!linkText ? linkText : (!!buttonRoute ? 'Details' : 'Event Details')) + '<i class=\'fas fa-arrow-right\'></i>'"
          [linkRoute]="linkRoute"
          [linkClasses]="linkClasses"
          [fullCardClick]="fullCardClick"
          [bottomRight]="bottomRight"
          [bottomRightClasses]="bottomRightClasses"
          [bottomRightTextClasses]="bottomRightTextClasses"
          [linkAboveDescription]="linkAboveDescription">
  <ng-content></ng-content>
</app-card>
